import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "utils/react-query.js";
import { updateBookmarkFolder } from "./api";

export const useUpdateBookmarkFolder = () => {
    return useMutation({
        mutationFn: async ({ projectId, item }) => {
            const response = await updateBookmarkFolder({ projectId, item });
            return response;
        },
        onSuccess: () => {
            toast.success("Bookmark Folder created successfully");
            queryClient.invalidateQueries();
        },
        onError: (error) => {
            toast.error(error.message);
            console.error(error.message);
        },
    });
}